import { Formik } from 'formik';
import { IAdditionalDocument, IDocumentPropertiesResponse, IGetInfoResponse, IOrganizationInfo, IRegisterRequest } from '../../models/income.model';
import { Button, Grid, Typography } from '@mui/material';
import CustomisedDropDown from '../../components/dropDown/dropDown';
import CustomisedTextField from '../../components/textField/textField';
import { useEffect, useRef, useState } from 'react';
import CustomisedCardUpload from '../../components/card/cardUpload';
import CustomisedButton from '../../components/button/button';
import { IDropDownResponse, IGetFormRejectReasonsResponse } from '../../models/registration.model';
import { IUploadFile } from '../../models/uploadFile.model';
import CustomisedCardLoad from '../../components/card/cardLoad';
import { useMutation, useQueryClient } from 'react-query';
import { getIncomeRangeOptions, getInfo, register, registerDocument, removeDocument, update } from '../../services/income.service';
import { IDocumentRequest, IDocumentResponse, IRegisterDocumentRequest } from '../../models/identity.model';
import { useDispatch } from 'react-redux';
import { setHeaderTitle } from '../../redux/headerTitle/headerTitleSlice';
import { getFormRejectReasons } from '../../services/registration.service';
import CustomisedErrorCard from '../../components/card/errorCard';
import JobInformationSkeleton from './jobInformationSkeleton';
import { IFormInnerState } from '../requestSteps/form/IFormInnerState';
import { DOCUMENT_TYPES, INCOME_RANGE_JOB } from '../../config/cacheKey';
import { changeRouteType, getNextInnerState, getpervInnerState } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { useAppBar } from '../../components/appBar/appBarContext';
import CustomisedCardLine from '../../components/card/cardLine';
import CustomisedTitleFont14 from '../../components/title/titleFont14';
import DownloadFile from '../../components/downloadFile/downloadFile';

export default function JobInformation({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {
    const [jobTitle, setJobTitle] = useState('');
    const [jobOrganization, setJobOrganization] = useState('');
    const [jobAddress, setJobAddress] = useState('');
    const [selectedCount, setSelectedPart] = useState();
    const [file, setFile] = useState<any>();
    const [fileArray, setFileArray] = useState<IUploadFile[]>([]);
    const [fileInArray, setFileInArray] = useState<File[]>([]);
    const [jobStatus, setJobStatus] = useState<IDropDownResponse>();
    const [jobStateTitle, setJobStateTitle] = useState<string>();
    const [jobStateId, setJobStateId] = useState<number>();
    const [incomeRange, setIncomeRange] = useState<IDropDownResponse[]>([]);
    const [document, setDocument] = useState<IDocumentResponse[]>([]);
    const [data, setData] = useState<IGetInfoResponse>();
    const [delImage, setDelImage] = useState<boolean>(false);
    const [rejectReasons, setRejectReasons] = useState<string[]>([]);
    const [getDocumentTypeService, setGetDocumentTypeService] = useState<string[]>([]);
    const [documentType, setDocumentType] = useState<any>();
    const [organizationInfo, setOrganizationInfo] = useState<IOrganizationInfo>();
    const [additionalDocuments, setAdditionalDocuments] = useState<IAdditionalDocument>();
    const randomKeyForDispatch = Math.random();
    const dispatch = useDispatch();
    const buttonRef = useRef<any>(null)
    const { setHeader } = useAppBar();

    const jobTitleHandleChange = (e: any) => {
        setJobTitle(e.target.value);
    };
    const jobOrganizationHandleChange = (e: any) => {
        setJobOrganization(e.target.value);
    };
    const jobAddressHandleChange = (e: any) => {
        setJobAddress(e.target.value);
    };

    useEffect(() => {
        setGetDocumentTypeService(JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!));
        // dispatch(setHeaderTitle({ header: 'اطلاعات شغلی', color: '#0057CC', parentRoute: 'job', }));
        setHeader('اطلاعات شغلی', 'jobInformation');
        GetIncomeRangeOptionsMutate();
        GetInfoMutate({ referenceKey: referenceKey! });
        GetRejectReasonsResidenceMutate({
            referenceKey: referenceKey!,
            form: 'Incomes'
        })
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'forms' + randomKeyForDispatch }));
        queryClient.setQueryData(INCOME_RANGE_JOB, '');
        setFileArray([]);
    }, []);
    useEffect(() => {
        getDocumentTypeService?.map((item: any) =>
            item.documentType === "Incomes" ? setDocumentType(item) : ''
        )
    }, [getDocumentTypeService])

    useEffect(() => {
        if (file !== undefined && documentType?.fileExtensions.includes(file.file.type)) {
            setFileArray([...fileArray, file]);
            setFileInArray([...fileInArray, file.file!]);
        }
        if (file !== undefined && data?.incomeRangeOptionId !== null) {
            const registerDocument = {} as IRegisterDocumentRequest;
            const reader = new FileReader();
            if (file?.file) {
                reader.readAsDataURL(file?.file!);
            }
            reader.onloadend = () => {
                registerDocument.base64Date = reader.result!;
            };
            registerDocument.base64Date = file?.fileUrl ? file?.fileUrl : '';
            registerDocument.documentType = 'Incomes';
            registerDocument.referenceKey = referenceKey!;
            registerDocument.data = file?.file!;
            RegisterDocumentMutate(registerDocument);
        }

    }, [file]);

    useEffect(() => {
        setJobStateTitle(jobStatus?.title);
        setJobStateId(jobStatus?.id);
    }, [jobStatus]);

    useEffect(() => {
        setDelImage(false);
        if (delImage === true) {
            GetInfoMutate({ referenceKey: referenceKey! })
        }
    }, [delImage]);

    const { mutate: GetIncomeRangeOptionsMutate } = useMutation(
        getIncomeRangeOptions,
        {
            onSuccess: (data: IDocumentPropertiesResponse[]) => {
                if (data) {
                    setIncomeRange(data)
                }
            },
        }
    );
    const { mutate: RegisterMutate } = useMutation(
        register,
        {
            onSuccess: (data: boolean) => {
                if (data) {
                    setFormInnerState!('formList');
                }
            },
        }
    );
    const { mutate: UpdateMutate } = useMutation(
        update,
        {
            onSuccess: (data: boolean) => {
                if (data) {
                    setFormInnerState!('formList');
                }
            },
        }
    );

    const { mutate: GetInfoMutate, isLoading } = useMutation(
        getInfo,
        {
            onSuccess: (data: IGetInfoResponse) => {
                if (data) {
                    setData(data);
                    setJobTitle(data.jobTitle!);
                    setJobOrganization(data.jobOrganization!);
                    setJobAddress(data.jobAddress!);
                    setJobStateTitle(data.incomeTitle!);
                    setJobStateId(data.incomeRangeOptionId ? data.incomeRangeOptionId : queryClient.getQueryData(INCOME_RANGE_JOB));
                    setDocument(data.documents);
                    setOrganizationInfo(data.organizationInfo);
                    setFileArray([]);
                    setFileInArray([]);
                    setAdditionalDocuments(data.additionalDocuments);
                }
            },
        }
    );
    const { mutate: RegisterDocumentMutate } = useMutation(
        registerDocument,
        {
            onSuccess: (data: IDocumentResponse) => {
                if (data) {
                    setDocument([...document, data]);
                }
            },
        }
    );
    const currentSelection = (e: any) => {
        setSelectedPart(
            e.target.value.substring(
                e.target.selectionStart,
                e.target.selectionEnd
            ).length
        );
    };
    const setChildValue = (childValues: any) => {
        let arrayFile: File[] = [];
        let newArray = fileArray?.filter(
            (item: any) => item.fileUrl !== childValues.fileUrl
        );
        setFileArray(newArray);
        newArray.map((item: any) =>
            arrayFile.push(item.file)
        )
        setFileInArray(arrayFile);

    };
    const { mutate: GetRejectReasonsResidenceMutate } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {
                if (data) {
                    setRejectReasons(data[0]?.rejectReasons)
                }
            },
        }
    );
    const handleContinue = () => {

    }
    const queryClient = useQueryClient()
    useEffect(() => {
        queryClient.setQueryData(INCOME_RANGE_JOB, jobStatus?.id)
    }, [jobStatus])
    const arrayList = [
        {
            title: organizationInfo?.title,
        },
        {
            title: organizationInfo?.description
        }
    ]

    if (isLoading) {
        return <JobInformationSkeleton />
    } else {
        return (
            <div className="container-height-drawer">
                <div className='content-container'>
                    <div className='drawer-content'>
                        <Formik
                            initialValues={{} as IRegisterRequest}
                            onSubmit={(values: IRegisterRequest) => {
                                values.files = fileInArray;
                                values.incomeRangeOptionId = jobStateId!;
                                values.jobAddress = jobAddress!;
                                values.jobOrganization = jobOrganization!;
                                values.jobTitle = jobTitle!;
                                values.referenceKey = referenceKey!;
                                (data?.jobTitle === undefined || data?.jobTitle === null)
                                    && data?.documents.length === 0
                                    ?
                                    RegisterMutate(values) : UpdateMutate(values)
                            }}
                        >
                            {({
                                handleSubmit,
                                handleChange,
                                values,
                                errors,
                                touched,
                                handleBlur,
                            }) => (
                                <form
                                    onSubmit={handleSubmit}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSubmit();
                                        }
                                    }}
                                >
                                    <div className="centerClass" >
                                        <Grid
                                            container
                                            className="row"
                                            spacing={2}
                                            style={{
                                                alignItems: 'center',
                                                width: '98%',
                                                margin: 'auto',
                                            }}
                                        >
                                            {rejectReasons?.length > 0 ? <Grid
                                                container
                                                className="row pb-5"
                                                spacing={2}
                                                style={{
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    margin: 'auto',
                                                }}
                                            >
                                                <CustomisedErrorCard titleList={rejectReasons} />
                                            </Grid> : ""
                                            }
                                            {
                                                organizationInfo ?
                                                    <div style={{ marginBottom: '30px', width: '100%' }}>
                                                        <CustomisedCardLine
                                                            itemList={arrayList}
                                                        /></div> :
                                                    null
                                            }
                                            {
                                                additionalDocuments && additionalDocuments.additionalDocumentItems?.length > 0 ?
                                                    <>
                                                        <DownloadFile additionalDocuments={additionalDocuments!} referenceKey={referenceKey || ''} />
                                                        <hr style={{ marginBottom: '30px', width: '100%', height: "1.5px", marginTop: '10px' }} />
                                                    </> : null
                                            }

                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    padding: '0px',
                                                    marginBottom: '2rem',
                                                }}
                                            >
                                                <Typography style={{ paddingBottom: '0.6rem' }}>
                                                    <CustomisedTitleFont14 title={'اطلاعات درآمدی'} />
                                                </Typography>
                                                <CustomisedDropDown
                                                    title={
                                                        jobStateTitle
                                                            ? jobStateTitle
                                                            : jobStatus
                                                                ? jobStatus.title
                                                                : 'میانگین درآمد'
                                                    }
                                                    options={incomeRange!}
                                                    label="میانگین درآمد"
                                                    setSelectedItem={setJobStatus}
                                                    isSelected={jobStateTitle ? true : false}
                                                ></CustomisedDropDown>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    padding: '0px',
                                                    marginBottom: '2rem',
                                                }}
                                            >
                                                <CustomisedTextField
                                                    helperText={!touched.jobTitle ? errors.jobTitle : ""}
                                                    error={!touched.jobTitle && Boolean(errors.jobTitle)}
                                                    label="عنوان شغل"
                                                    placeholder={''}
                                                    required={true}
                                                    inputProps={{ type: 'string' }}
                                                    value={jobTitle}
                                                    onChange={jobTitleHandleChange}
                                                    name="jobTitle"
                                                    id="jobTitle"
                                                    onSelect={currentSelection}
                                                />
                                            </Grid>
                                            {organizationInfo ? null :
                                                <>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        style={{
                                                            padding: '0px',
                                                            marginBottom: '2rem',
                                                        }}
                                                    >
                                                        <CustomisedTextField
                                                            helperText={!touched.jobOrganization ? errors.jobOrganization : ""}
                                                            error={!touched.jobOrganization && Boolean(errors.jobOrganization)}
                                                            label="عنوان محل اشتغال"
                                                            placeholder={''}
                                                            required={true}
                                                            inputProps={{ type: 'string' }}
                                                            value={jobOrganization}
                                                            onChange={jobOrganizationHandleChange}
                                                            name="jobOrganization"
                                                            id="jobOrganization"
                                                            onSelect={currentSelection}
                                                        />
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        style={{
                                                            padding: '0px',
                                                            marginBottom: '2rem',
                                                        }}
                                                    >
                                                        <CustomisedTextField
                                                            helperText={!touched.jobAddress ? errors.jobAddress : ""}
                                                            error={!touched.jobAddress && Boolean(errors.jobAddress)}
                                                            label="آدرس محل اشتغال"
                                                            placeholder={''}
                                                            required={true}
                                                            inputProps={{ type: 'string' }}
                                                            value={jobAddress}
                                                            onChange={jobAddressHandleChange}
                                                            name="jobAddress"
                                                            id="jobAddress"
                                                            onSelect={currentSelection}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={12} style={{ padding: '0px' }}>
                                                {
                                                    document != undefined &&
                                                        document != null &&
                                                        document.length > 0 ? (
                                                        <>
                                                            {document?.map((item) => (
                                                                <CustomisedCardLoad
                                                                    comment={documentType?.hints?.length > 100 ?
                                                                        documentType?.hints.slice(0, 100) + '...' : documentType?.hints}
                                                                    title={
                                                                        item?.documentTypeTitle
                                                                    }
                                                                    fileSelected={
                                                                        item?.fileUrl
                                                                    }
                                                                    documentId={
                                                                        item?.fileId
                                                                    }
                                                                    setDelImage={
                                                                        setDelImage
                                                                    }
                                                                    setChildValue={
                                                                        setChildValue
                                                                    }
                                                                    fileArray={fileArray}
                                                                    serviceName={
                                                                        removeDocument
                                                                    }
                                                                    serviceRequestObj={
                                                                        {
                                                                            referenceKey: referenceKey!,
                                                                            documentId:
                                                                                item?.fileId,
                                                                        } as IDocumentRequest
                                                                    }
                                                                    fileType={item.fileType}
                                                                />
                                                            ))}
                                                            <CustomisedCardUpload
                                                                title={documentType?.title}
                                                                comment={documentType?.hints?.length > 100 ?
                                                                    documentType?.hints.slice(0, 100) + '...' : documentType?.hints}
                                                                setFileSelected={setFile}
                                                                fileExtensions={documentType?.fileExtensions}
                                                                maxSizeKb={documentType?.maxSizeKb}
                                                                fileType={documentType?.fileType}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            {
                                                                fileArray.map((fileArray) => (
                                                                    <CustomisedCardLoad
                                                                        comment={documentType?.hints?.length > 100 ?
                                                                            documentType?.hints.slice(0, 100) + '...' : documentType?.hints}
                                                                        title={documentType?.title}
                                                                        fileSelected={
                                                                            fileArray.fileUrl
                                                                        }
                                                                        setChildValue={
                                                                            setChildValue
                                                                        }
                                                                        fileArray={fileArray}
                                                                        fileType={fileArray?.file?.type}
                                                                    />

                                                                ))}

                                                            {documentType !== null && documentType !== undefined ?
                                                                <CustomisedCardUpload
                                                                    title={documentType?.title}
                                                                    comment={documentType?.hints?.length > 100 ?
                                                                        documentType?.hints.slice(0, 100) + '...' : documentType?.hints}
                                                                    setFileSelected={setFile}
                                                                    fileExtensions={documentType?.fileExtensions}
                                                                    maxSizeKb={documentType?.maxSizeKb}
                                                                    fileType={documentType?.fileType}
                                                                /> : null
                                                            }
                                                        </>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                        <div className="button-container">
                                            <Button
                                                onClick={handleContinue}
                                                type="submit"
                                                ref={buttonRef}
                                                style={{ display: "none" }}
                                            ></Button>
                                        </div>

                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            onClick={() => {
                                if (buttonRef.current) {
                                    buttonRef.current.click()
                                }
                            }}
                            title='بارگذاری و ارسال'
                            type='button'
                            disable={!organizationInfo ?
                                jobAddress === null || jobOrganization === "" ||
                                jobTitle === "" || (jobStatus === undefined && jobStateId === undefined) ||
                                (fileArray.length === 0 && document.length === 0) :
                                jobTitle === "" || (jobStatus === undefined && jobStateId === undefined) ||
                                    (fileArray.length === 0 && document.length === 0) ? true : false}

                        />

                    </div>
                </div>
            </div>
        );
    }
}


